/**
 * Funnel beacon — fires anonymous events to /api/funnel/event.
 * Uses navigator.sendBeacon when available (non-blocking, survives unload).
 */
import { getBackendUrl } from './api';

const STORAGE_KEY = 'tp_funnel_fp';

const getFingerprint = () => {
  try {
    let fp = localStorage.getItem(STORAGE_KEY);
    if (!fp) {
      fp = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(STORAGE_KEY, fp);
    }
    return fp;
  } catch {
    return null;
  }
};

const sentOnce = new Set();

/**
 * Record a funnel event. Deduplicates per fingerprint+event during the session
 * to avoid bursts (multiple onChange triggers etc.).
 *
 * @param {'landing_view'|'form_started'} eventType
 * @param {object} [meta] — { source, country, category }
 */
export const trackFunnel = (eventType, meta = {}) => {
  if (typeof window === 'undefined') return;

  const fp = getFingerprint();
  const dedupeKey = `${eventType}:${meta.source || ''}`;
  if (sentOnce.has(dedupeKey)) return;
  sentOnce.add(dedupeKey);

  const body = JSON.stringify({
    event_type: eventType,
    source: meta.source || window.location.pathname,
    country: meta.country,
    category: meta.category,
    fingerprint: fp,
  });

  const url = `${getBackendUrl()}/api/funnel/event`;
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // never break user flow over a tracking failure
  }
};
